import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, BriefcaseBusiness, CalendarCheck2, Info, LayoutGrid, Stethoscope, Target } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const HOME_INTERNAL_LINKS = Object.freeze([
  { key: 'about', path: '/about', icon: Info },
  { key: 'services', path: '/services', icon: LayoutGrid },
  { key: 'clinicWebsiteDesign', path: '/services/clinic-website-design', icon: Stethoscope },
  { key: 'conversionFocusedWebsites', path: '/services/conversion-focused-websites', icon: Target },
  { key: 'work', path: '/work', icon: BriefcaseBusiness },
  { key: 'resources', path: '/resources', icon: BookOpen },
  { key: 'bookCall', path: '/book-call', icon: CalendarCheck2 },
]);

const HomeInternalLinks = () => {
  const { t } = useLanguage();

  return (
    <section className="relative border-y border-white/[0.07] bg-[#050706] py-12">
      <div className="mx-auto max-w-[1400px] px-5 md:px-[7.6923%]">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {HOME_INTERNAL_LINKS.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className="group flex min-h-[92px] items-center justify-between gap-4 rounded-2xl border border-white/[0.08] bg-white/[0.025] px-5 py-4 text-white/72 transition-all hover:-translate-y-1 hover:border-[#00FFD1]/30 hover:bg-[#00FFD1]/[0.035] hover:text-white"
              >
                <span className="flex min-w-0 items-center gap-3">
                  <span className="flex h-10 w-10 flex-none items-center justify-center rounded-xl border border-[#00FFD1]/25 bg-[#00FFD1]/10 text-[#00FFD1]">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="min-w-0 text-sm font-semibold md:text-base">{t(`nav.${item.key}`)}</span>
                </span>
                <ArrowRight className="h-4 w-4 flex-none text-[#00FFD1] transition-transform group-hover:translate-x-1" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeInternalLinks;
